var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.5,
    y: 1.35059,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#141BEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26.8506H13V17.8506H16V26.8506Z",
    fill: "#141BEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4911 15.8506H14.474C13.5788 15.8506 13 15.1836 13 14.3501C13 13.4989 13.5964 12.8506 14.5087 12.8506C15.4209 12.8506 15.9827 13.4989 16 14.3501C16 15.1836 15.4209 15.8506 14.4911 15.8506Z",
    fill: "#141BEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 26.8504H24.0519V22.1459C24.0519 20.9643 23.6253 20.158 22.5581 20.158C21.7437 20.158 21.2586 20.7016 21.0455 21.2266C20.9675 21.4147 20.9484 21.6769 20.9484 21.9397V26.8506H18C18 26.8506 18.0389 18.8824 18 18.0573H20.9484V19.3028C21.3397 18.7041 22.0405 17.8506 23.6057 17.8506C25.5456 17.8506 27 19.1076 27 21.8086L26.9999 26.8504Z",
    fill: "#141BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4b1565b0ada1eeec6081b9fe9dcb7b7f.svg";
export { ForwardRef as ReactComponent };